import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import API from '../../api';
import { Button, Stepper } from '../../components';
import { SnackbarContext } from '../../contexts';
import { useLabel } from '../../hooks';
import { SignUpTerms } from './SignUpTerms';
import { SignUpForm } from './components/sign-up/SignUpForm';
import { useSignUp } from './components/sign-up/hooks';

export const UserSignUpPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { initialValues, signUpResult, postSignUp } = useSignUp();
  const { updateSnackbar } = useContext(SnackbarContext);
  const [step, setStep] = useState(0);
  const [termsChecks, setTermsChecks] = useState([false, false, false, false]);
  const { MSG, ERROR } = useLabel();
  const [googleAddress, setGoogleAddress] = useState(null);
  const {
    control,
    handleSubmit,
    register,
    watch,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues,
  });

  const onChangeStep = (new_value) => {
    setStep(new_value);
  };

  const onSubmit = (data) => {
    postSignUp(data, termsChecks, (result) => {
      setStep(2);
    });
  };

  useEffect(() => {
    window?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [step]);

  return (
    <article className='basic-page pt-10'>
      <article className='content__wrapper'>
        <section className='heading-text__container'>
          <header>
            <h1>{t('SIGN_UP')}</h1>
          </header>
        </section>
        <section className='user-stepper__container'>
          <Stepper
            meta={{}}
            value={step}
            label={[t('AGREE_TO_TERM'), t('ENTER_INFO'), t('EMAIL_VERIFICATION')]}
            onChange={onChangeStep}
          ></Stepper>
        </section>
        {step === 0 && (
          <section className='user-form__container'>
            <SignUpTerms onChange={(terms) => setTermsChecks(terms)} />
            <section className='button__container'>
              <Button
                style={{ width: '180px', marginRight: 24 }}
                onClick={() => {
                  history.push('/user/signup_guide');
                }}
                label={t('PREV')}
                type='secondary'
              ></Button>
              <Button
                style={{ width: '180px' }}
                onClick={() => {
                  if (termsChecks[0] && termsChecks[1] && termsChecks[2]) {
                    setStep(1);
                  } else {
                    updateSnackbar({
                      type: 'error',
                      open: true,
                      message: ERROR['REQUIRED_TERM'],
                    });
                  }
                }}
                label={t('NEXT')}
              ></Button>
            </section>
          </section>
        )}
        {step === 1 && (
          <SignUpForm
            register={register}
            setValue={setValue}
            handleSubmit={handleSubmit}
            watch={watch}
            onSubmit={onSubmit}
            control={control}
            setError={setError}
            errors={errors}
            setStep={setStep}
            googleAddress={googleAddress}
            setGoogleAddress={setGoogleAddress}
          />
        )}
        {step === 2 && (
          <section className='user-eamil__container'>
            <section className='mail__box'>
              <div className='image'></div>
              <h1>{MSG['EMAIL_SEND']}</h1>
            </section>
            <section className='value__box'>
              <h2>{watch('email')}</h2>
            </section>
            <section className='guide__box'>
              <span>{MSG['EMAIL_SEND_SIGN_UP']}</span>
            </section>
            <section className='info__box'>
              <ul>
                <li>* {MSG['CHECK_SPAM_MAIL']}</li>
                <li>
                  *{' '}
                  <em
                    onClick={() => {
                      API.User.PutSignupEmailResend({ key: signUpResult.key }).then(
                        (res) => {
                          updateSnackbar({
                            type: 'success',
                            open: true,
                            message: MSG['MAIL_RESEND_SUCCESS'],
                          });
                        },
                        (err) => {
                          updateSnackbar({
                            type: 'error',
                            open: true,
                            message: err.data.message,
                          });
                        },
                      );
                    }}
                  >
                    {t('IF_YOU_NEED_RESEND')}
                  </em>
                </li>
              </ul>
            </section>
          </section>
        )}
      </article>
    </article>
  );
};
